import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#3882F0',
        secondary: '#EBF4FF',
        blue: {
          base: '#3882F0',
          darken1: '#2750AE',
          darken2: '#102046',
          lighten1: '#9CC1F8',
          lighten2: '#E7F0FD',
        },
        purple: {
          base: '#8B46FF',
          darken1: '#6B1CB0',
          darken2: '#280b42',
          lighten1: '#CDB0FF',
          lighten2: '#EFE6FE',
        },
        red: {
          base: '#F82B60',
          darken1: '#BA1E45',
          darken2: '#400832',
          lighten1: '#FF9EB7',
          lighten2: '#FFE5EC',
        },
        orange: {
          base: '#FF6F2C',
          darken1: '#D74D26',
          darken2: '#6b2613',
          lighten1: '#FFA981',
          lighten2: '#FEEAE1',
        },
        teal: {
          base: '#20D9D2',
          darken1: '#06A09B',
          darken2: '#012524',
          lighten1: '#71EFE0',
          lighten2: '#DCF9F2',
        },
        green: {
          base: '#20C933',
          darken1: '#338A17',
          darken2: '#0B1D05',
          lighten1: '#93E088',
          lighten2: '#E3FADB',
        },
        yellow: {
          base: '#FCB400',
          darken1: '#B87503',
          darken2: '#3B2501',
          lighten1: '#FFD66E',
          lighten2: '#FFF3D6',
        },
        'blue-grey': {
          base: '#A0AEC0',
          lighten1: '#CBD5E0',
          lighten2: '#E2E8F0',
          lighten3: '#F2F5FA',
          darken1: '#718096',
          darken2: '#4A5568',
          darken3: '#2D3748',
        },
      },
    },
    options: {
      customProperties: true,
    },
  },
  icons: { iconfont: 'mdi' },
})
